import React from 'react';
import DisplayLarge from './display-large';
import DisplaySmall from './display-small';
import H2 from './h2';
import H3 from './h3';
import H4 from './h4';
import SmallText from './small-text';
import BodyText from './body-text';
import LargeText from './large-text';
import TighterLargeText from './tighter-large-text';
import Lead from './lead';
import Container from './text.styled';
var Text = function Text(_ref) {
    var textType = _ref.textType, stringText = _ref.stringText, richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles, bulletType = _ref.bulletType;
    var getTextComponent = function getTextComponent() {
        switch (textType) {
            case 'displayLarge':
                return /*#__PURE__*/ React.createElement(DisplayLarge, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'displaySmall':
                return /*#__PURE__*/ React.createElement(DisplaySmall, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'h2':
                return /*#__PURE__*/ React.createElement(H2, {
                    stringText: stringText || '',
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'h3':
                return /*#__PURE__*/ React.createElement(H3, {
                    stringText: stringText || '',
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'h4':
                return /*#__PURE__*/ React.createElement(H4, {
                    stringText: stringText || '',
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'smallText':
                return /*#__PURE__*/ React.createElement(SmallText, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'bodyText':
                return /*#__PURE__*/ React.createElement(BodyText, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'largeText':
                return /*#__PURE__*/ React.createElement(LargeText, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'tighterLargeText':
                return /*#__PURE__*/ React.createElement(TighterLargeText, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            case 'lead':
                return /*#__PURE__*/ React.createElement(Lead, {
                    richText: richText || [],
                    color: color || '',
                    customStyles: customStyles || ''
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ React.createElement(Container, {
        bulletType: bulletType || ''
    }, getTextComponent());
};
export default Text;
